import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import AuthContext from "../../context/auth/authContext";
import { IoIosCloseCircleOutline } from "react-icons/io";
import parameterContext from "../../context/parameter/parameterContext";
const ForgotPasswordOTPScreen = () => {
  const { loading, changePassword } = useContext(AuthContext);
  const {toggleModal}=useContext(parameterContext)
  const [details, setDetails] = useState({ otp: "", password: "" });

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };
  const handleSubmit = () => {
    if (details.otp === "" || details.password === "") {
      toast.error("Fields cannot be empty", { autoClose: 6000 });
    } else if (
      !/^(?=^.{8,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(
        details.password
      )
    ) {
      toast.error("Please choose a strong password", { autoClose: 6000 });
    } else {
      const id = localStorage.getItem("idForPassword");
      if (id) {
        changePassword({
          otp: Number(details.otp),
          password: details.password,
          id,
        });
      }
    }
  };

  return (
    <div className="Register">
      <div className="Login__container">
      <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={toggleModal}
          />
        </div>
        <div className="Register__content">
          <h2>Verify OTP</h2>
          <p>
            An verification OTP has been sent to your registered email to reset
            your password.Please enter it here. and then enter your new
            password.
          </p>
        </div>
        <div className="Register__form">
          <p>Enter OTP</p>
          <input
            type="number"
            value={details.otp}
            onChange={handleChange}
            name="otp"
          />
          <p>Enter New Password</p>
          <input
            type="text"
            value={details.password}
            onChange={handleChange}
            name="password"
          />

          <div className="Register__footer">
            <button className="Register__button" onClick={handleSubmit}>
              Done
              {loading && (
                <div
                  className="loader1"
                  style={{
                    height: "20px",
                    width: "20px",
                    display: "inline-block",
                    border: "3px solid #f3f3f3",
                    borderTop: "3px solid #8d0792",
                    marginLeft: "5px",
                  }}
                ></div>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordOTPScreen;
